/**
 * Función para obtener la variación DRC látex
 * @param {*} data - Datos de ingreso con la finca
 * @returns { aplica: boolean, variacion: number } - Objeto con la variación DRC látex y si aplica o no
 */
export const getVariacionDRCLatexFromFinca = (data) => {
    let variacionDRC = { aplica: false, variacion: 0 };

    let finca = {};
    if (data && data.ingreso && data.ingreso.finca) {
        finca = data.ingreso.finca;
    }

    if (!finca || !finca.aplica_variacion_drc){
        return variacionDRC;
    }

    const historial_variacion_drc = finca && finca.historial_variacion_drc;

    if (historial_variacion_drc && historial_variacion_drc.length > 0) {
        const variacionDRCLatex = historial_variacion_drc[historial_variacion_drc.length - 1].variacion_drc_latex;
        variacionDRC = { aplica: true, variacion: variacionDRCLatex };
    }

    return variacionDRC;
}

/**
 * Función para calcular el DRC látex
 * @param {*} registroDRC - Registro de DRC látex
 * @returns {number} - DRC látex
 */
export const calcularDRCLatex = (registroDRC) => {
    const { peso_seco, peso_plato_ajustado, peso_humedo } = registroDRC;

    const DRC = ((peso_seco - peso_plato_ajustado) / peso_humedo);
    return DRC;
}

/**
 * Función para calcular el DRC látex original
 * @param {*} registroDRC - Registro de DRC látex
 * @returns {number} - DRC látex original
 */
export const calcularDRCLatexOriginal = (registroDRC) => {
    const { peso_seco_original, peso_plato, peso_humedo } = registroDRC;

    const DRC = ((peso_seco_original - peso_plato) / peso_humedo);
    return DRC;
}
